export const scrollElementIntoViewById = (htmlId: string) => {
  const element = document.getElementById(htmlId);
  if (!element) return;

  scrollElementIntoView(element);
};

export const scrollElementIntoView = (element: Element) => {
  const elementPosition = element.getBoundingClientRect().top;
  scrollIntoViewByPosition(elementPosition);
};

export const scrollIntoViewByPosition = (top: number) => {
  const appBarHeight = 64;
  const scrollTopOffset = 45;
  const menuElement = document.querySelector('.cms-menubar');
  const menuHeight = menuElement ? menuElement.getBoundingClientRect().height : 0;
  const headerOffset = menuHeight;
  const offsetPosition = top + window.scrollY - (headerOffset + appBarHeight + scrollTopOffset);
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
